import Vue from "vue";
import Vuex from "vuex";

// import createPersistedState from "vuex-persistedstate";

// import { UserState } from "./modules/user";

// import { SoapState } from "./modules/soap";
// // import { DokterState } from "./modules/dokter";
// import { AppState } from "./modules/app";
// // // import ResepStore from "./modules/reseps";
// import { SpriState } from "./modules/spri";

Vue.use(Vuex);

// interface RootState {
//   appState: AppState;
//   userState: UserState;

//   soapState: SoapState;
//   spriState: SpriState;
//   // dokterState: DokterState;
// }

// export default new Vuex.Store<RootState>({
//   // plugins: [createPersistedState({ storage: window.sessionStorage })] // !debug ? [createPersistedState({ storage: window.sessionStorage })] : [],
// });

export default new Vuex.Store({});
